"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BannerImage1 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig1.avif";
import BannerImage2 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig2.avif";
import BannerImage3 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig3.avif";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import { fragenAutoUmschreibenBesitzUebertragen } from "./data";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function AutoUmschreibenBesitzUebertragen() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Auto umschreiben & Besitz übertragen – so klappt’s"
        link="/guides/auto-umschreiben-besitz-uebertragen"
        linkname="Auto umschreiben"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Auto ummelden auf andere Person"
              leftText={
                <>
                  <p>
                    Ein Auto zu verkaufen oder zu verschenken klingt zunächst
                    einfach: Du findest einen Käufer, einigen dich auf einen
                    Preis und übergibst Fahrzeug und Schlüssel. Doch ein
                    entscheidender Schritt wird dabei gerne vergessen – die
                    Umschreibung. In Österreich und Deutschland gilt: Sobald der
                    Halter wechselt oder sich relevante Daten ändern, muss dies
                    der Zulassungsbehörde gemeldet und in den Fahrzeugpapieren
                    dokumentiert werden. Eine korrekte Ummeldung schützt dich
                    vor unnötigen Kosten, Bußgeldern und
                    versicherungstechnischen Problemen. Dieser ausführliche
                    Ratgeber erklärt dir Schritt für Schritt, wann eine
                    Umschreibung nötig ist, welche Unterlagen du brauchst,
                    welche Fristen gelten und wie der gesamte Prozess
                    reibungslos abläuft. Am Ende weißt du genau, wie du die
                    bürokratischen Anforderungen meisterst und dich entspannt
                    auf den Verkauf oder die Übergabe deines Autos konzentrieren
                    kannst.
                  </p>
                </>
              }
              rightFirstTitle="Warum muss man ein Auto umschreiben?"
              rightFirstText={
                <>
                  <p>
                    Die Kfz-Zulassungsverordnung schreibt vor, dass die
                    Zulassungsbehörde über alle relevanten Änderungen informiert
                    werden muss. Das betrifft:
                  </p>

                  <ul className="custom-unordered-list">
                    <li>
                      <strong>
                        Halterwechsel (Verkauf, Schenkung, Erbschaft):
                      </strong>{" "}
                      Mit dem Eigentumswechsel geht auch die Halterverantwortung
                      über. Wird das Auto nicht umgeschrieben, bleibst du als
                      Vorbesitzer weiterhin für Steuern, Versicherung, Knöllchen
                      und eventuelle Schadensersatzforderungen haftbar.
                    </li>
                    <li>
                      <strong>Wohnsitz- oder Bezirkswechsel:</strong> Ziehst du
                      in einen anderen Bezirk oder Bundesland, muss der Wohnort
                      im Fahrzeugschein korrigiert werden. Ansonsten können
                      Strafen wegen einer falschen Zulassung erfolgen.
                    </li>
                    <li>
                      <strong>Namensänderungen:</strong> Auch eine Heirat oder
                      Scheidung, bei der sich dein Nachname ändert, muss in den
                      Papieren eingetragen werden.
                    </li>
                    <li>
                      <strong>Technische Änderungen:</strong> Bei relevanten
                      Umbauten (z. B. Leistungssteigerungen,
                      Fahrwerksänderungen) oder einer Motorumrüstung sind
                      ebenfalls neue Papiere erforderlich, die den aktuellen
                      Zustand dokumentieren.
                    </li>
                  </ul>

                  <p>
                    Die Umschreibung ist also nicht nur bei einem Verkauf nötig,
                    sondern in verschiedenen Lebenssituationen. Sie
                    gewährleistet, dass Versicherer und Behörden aktuelle Daten
                    haben und keine Altlasten an dir hängen bleiben.
                  </p>
                </>
              }
              rightSecondTitle="Rechtliche Grundlagen"
              rightSecondText={
                <>
                  <p>
                    In Österreich regelt das Kraftfahrgesetz (KFG) gemeinsam mit
                    der Kraftfahrzeug-Zulassungsverordnung (KFV) die
                    Zulassungspflicht von Fahrzeugen. Das Gesetz verpflichtet
                    Fahrzeughalter, Änderungen innerhalb einer bestimmten Frist
                    bei der Behörde anzuzeigen. Wer dem nicht nachkommt,
                    riskiert Verwaltungsstrafen, und der Versicherungsschutz
                    kann erlöschen. Bei einem Verkauf bleiben die Steuer- und
                    Versicherungsbeiträge so lange in der Verantwortung des
                    alten Halters, bis der neue Eigentümer die Umschreibung
                    vollzogen hat. Darum ist es wichtig, im Kaufvertrag eine
                    Frist festzulegen und gegebenenfalls selbst tätig zu werden.
                  </p>

                  <h3>Welche Dokumente werden benötigt?</h3>
                  <p>
                    Für eine Umschreibung brauchst du verschiedene Unterlagen.
                    Je nach Bundesland können die Anforderungen leicht
                    variieren; folgende Dokumente solltest du aber in jedem Fall
                    bereithalten:
                  </p>

                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Amtlicher Lichtbildausweis:</strong> Ein gültiger
                      Personalausweis oder Reisepass des neuen Halters.
                    </li>
                    <li>
                      <strong>
                        Zulassungsbescheinigung Teil I (Fahrzeugschein):
                      </strong>{" "}
                      Dokumentiert die Zulassung des Fahrzeugs zum
                      Straßenverkehr; muss beim Ummelden vorgelegt werden.
                    </li>
                    <li>
                      <strong>
                        Zulassungsbescheinigung Teil II (Fahrzeugbrief):
                      </strong>{" "}
                      Belegt das Eigentum am Fahrzeug. Wichtig bei
                      Halterwechsel.
                    </li>
                    <li>
                      <strong>Besitznachweis:</strong> Kaufvertrag,
                      Schenkungsvertrag oder Erbschein. Dieser dient als
                      rechtlicher Nachweis, dass das Eigentum übergegangen ist.
                    </li>
                    <li>
                      <strong>Versicherungsnachweis (eVB):</strong> Eine
                      elektronische Versicherungsbestätigung; ohne sie wird das
                      Fahrzeug nicht zugelassen.
                    </li>
                    <li>
                      <strong>Kennzeichen:</strong> Die bisherigen Nummerntafeln
                      müssen abgegeben oder umgemeldet werden. Du kannst auch
                      neue Nummernschilder beantragen (z. B. Wunschkennzeichen).
                    </li>
                    <li>
                      <strong>
                        Prüfbericht der letzten Hauptuntersuchung:
                      </strong>{" "}
                      In Österreich das aktuelle Pickerl, in Deutschland der
                      TÜV-Bericht. Das Pickerl darf nicht abgelaufen sein.
                    </li>
                    <li>
                      <strong>SEPA-Lastschriftmandat:</strong> Damit werden die
                      Kfz-Steuern künftig vom Konto des neuen Halters
                      eingezogen.
                    </li>
                    <li>
                      <strong>
                        Genehmigungsnachweis (Typenschein) und CoC-Papiere:
                      </strong>{" "}
                      Bei älteren Fahrzeugen und bei importierten Fahrzeugen
                      müssen Typenschein oder EU-Übereinstimmungsbescheinigung
                      vorgelegt werden.
                    </li>
                    <li>
                      <strong>Eventuell Vormundschaftsnachweis:</strong> Wenn
                      der Käufer minderjährig ist oder unter Betreuung steht,
                      sind zusätzliche Dokumente nötig.
                    </li>
                    <li>
                      <strong>Vollmacht:</strong> Falls der Halter nicht selbst
                      erscheint, sondern einen Dritten beauftragt, muss eine
                      schriftliche Vollmacht mitgebracht werden.
                    </li>
                  </ul>

                  <p>
                    Sammle diese Unterlagen vor dem Termin, um Verzögerungen zu
                    vermeiden. Bei fehlenden Dokumenten, etwa einem verlorenen
                    Fahrzeugbrief, sollte rechtzeitig ein Ersatz beantragt
                    werden.
                  </p>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage3}
                revert
                isBig
                fontSize="36px"
                title="Schritt-für-Schritt-Anleitung zur Umschreibung"
                alt="Schritt-für-Schritt-Anleitung zur Umschreibung eines Autos"
                text={
                  <>
                    <ul className="custom-unordered-list secondary">
                      <li>
                        <strong>Kauf- oder Übergabevertrag abschließen:</strong>
                        {" "}Halte den Kauf schriftlich fest. Gib im Vertrag den
                        Zustand des Fahrzeugs, Preis, Übergabedatum sowie eine
                        Frist für die Umschreibung an (z. B. drei Tage). So
                        hast du eine rechtliche Absicherung.
                      </li>
                      <li>
                        <strong>
                          Oldtimergutachten oder Gutachten bei Erbfall einholen:
                        </strong>
                        {" "}
                        Bei Erbschaften wird oft ein Nachweis über den
                        rechtmäßigen Erwerb gefordert. Oldtimer brauchen ggf.
                        eine spezielle Bestätigung.
                      </li>
                      <li>
                        <strong>
                          Versicherung für den neuen Halter abschließen:
                        </strong>
                        {" "}
                        Der Käufer sollte vor der Zulassung eine neue
                        Versicherung wählen und die eVB-Nummer bereithalten.
                      </li>
                      <li>
                        <strong>
                          Termin bei der Zulassungsstelle vereinbaren:
                        </strong>
                        {" "}
                        Gerade in Ballungsgebieten lohnt sich eine
                        Terminvereinbarung, um lange Wartezeiten zu vermeiden.
                        Manche Zulassungsbehörden bieten Online-Termine oder
                        sogar Online-Ummeldungen an.
                      </li>
                      <li>
                        <strong>Dokumente vorbereiten:</strong> Überprüfe noch
                        einmal, ob alle oben genannten Papiere vollständig sind.
                        Vergiss nicht den SEPA-Auftrag.
                      </li>
                      <li>
                        <strong>An der Zulassungsstelle:</strong> Reiche alle
                        Unterlagen ein. Die Mitarbeiter prüfen die Papiere,
                        ziehen die alten Kennzeichen und die alte
                        Zulassungsbescheinigung ein und stellen neue Dokumente
                        aus. Eventuell musst du neue Kennzeichen prägen lassen.
                      </li>
                      <li>
                        <strong>Steuer und Gebühren bezahlen:</strong> Die
                        Ummeldegebühr variiert je nach Bezirk (etwa 120–200 Euro
                        inklusive Kennzeichen). Die Kfz-Steuer wird per
                        SEPA-Mandat eingezogen.
                      </li>
                      <li>
                        <strong>Versicherung aktivieren:</strong> Nach der
                        Ummeldung ist die neue Versicherung aktiv. Die alte
                        Versicherung endet automatisch.
                      </li>
                      <li>
                        <strong>
                          Alte Versicherung und Behörden informieren:
                        </strong>
                        {" "}
                        Als Verkäufer solltest du deine Versicherung und das
                        Finanzamt schriftlich über den Halterwechsel
                        informieren, um sicherzustellen, dass du nicht weiter
                        Zahlungen leisten musst.
                      </li>
                      <li>
                        <strong>Nachweis aufbewahren:</strong> Bewahre eine
                        Kopie des neuen Fahrzeugscheins und den Kaufvertrag. So
                        kannst du jederzeit nachweisen, dass du nicht mehr
                        Halter bist.
                      </li>
                    </ul>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage1}
                h2
                isBig
                fontSize="36px"
                title="Kosten und Fristen"
                alt="Frau lächelt und schaut auf ihr Smartphone, während sie wichtige Schritte für den Autoverkauf plant."
                text={
                  <>
                    <p>
                      Die Kosten setzen sich aus der Zulassungsgebühr, den
                      Kennzeichen und einer eventuellen Wunschkennzeichengebühr
                      zusammen. Für das Pickerl oder den TÜV können weitere
                      Kosten anfallen. Eine Ummeldung sollte unverzüglich nach
                      der Eigentumsübertragung erfolgen. Oft wird eine Frist von
                      drei bis sieben Tagen empfohlen. Hält der neue Halter die
                      Frist nicht ein, kann der alte Besitzer die Ummeldung
                      selbst veranlassen, um sich von der Haftung zu befreien.
                      Etwaige Verwaltungskosten können dem Käufer in Rechnung
                      gestellt werden.
                    </p>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage2}
                revert
                h2
                isBig
                fontSize="36px"
                title="Tipps für eine reibungslose Umschreibung"
                alt="Ein Smartphone mit einem Verkaufsangebot für ein Auto, als Alternative zur Plattform Wir kaufen dein Auto"
                text={
                  <>
                    <ul>
                      <li>
                        Erstelle vor der Übergabe eine Checkliste aller
                        Dokumente.
                      </li>
                      <li>
                        Lass das Auto vor dem Verkauf noch einmal überprüfen und
                        beseitige kleinere Mängel; das erleichtert die
                        Hauptuntersuchung.
                      </li>
                      <li>
                        Wenn du in einen anderen Bezirk umziehst, informiere
                        dich über eventuell andere Regelungen (z. B. Pflicht für
                        Umweltplaketten).
                      </li>
                      <li>
                        Schütze dich mit einer Veräußerungsanzeige: Manche
                        Zulassungsstellen bieten ein Formular an, mit dem du den
                        Verkauf direkt meldest. Damit bist du sicher, dass die
                        Behörden den Wechsel registrieren.
                      </li>
                      <li>
                        Halte die Kommunikation mit dem Käufer offen. Frage
                        nach, ob er die Ummeldung erledigt hat, und bitte ihn
                        ggf. um eine Kopie des neuen Zulassungsscheins.
                      </li>
                    </ul>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="FAQ"
              fragen={fragenAutoUmschreibenBesitzUebertragen}
              image={FAQImage}
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Auto umschreiben"
                kaputtesAuto
                unfallAuto
                autoExport
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos ihr Auto sicher zu verkaufen."
                text={
                  <>
                    <p>
                      Die Umschreibung eines Autos ist kein bürokratisches
                      Monster, wenn man weiß, was zu tun ist. Sie schützt dich
                      als bisherigen Halter vor finanziellen und rechtlichen
                      Risiken. Mit einer gründlichen Vorbereitung, allen
                      notwendigen Dokumenten und klaren Fristen verläuft der
                      Halterwechsel reibungslos. Wenn du dein Auto über
                      Autoeinfachlos verkaufst, übernehmen unsere Partner die
                      Ummeldung für dich – du sparst Zeit und kannst sicher
                      sein, dass alles korrekt abläuft.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default AutoUmschreibenBesitzUebertragen;
